import styled from 'styled-components';

export const StyledDeleteChatModal = styled.div`
  width: 100%;
  .desc {
    font-size: 18px;
    line-height: 22px;
    font-weight: 600;
    margin-bottom: 40px;
    color: var(--white);

    @media (min-width: 576px) {
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 70px;
    }
  }
  .btn-holder {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }
`;
